import * as React from 'react';
import AppBar from '@mui/material/AppBar';

import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import "../css/navbarleading.css";
import { Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import Stack from '@mui/material/Stack';
// import landingLogo from "../image/MEDDAILY-LOGO-inverted.png";
import logo from "../image/catalog/logonew.jpg";
export default function NavbarLanding() {

    return (

        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static" >
                <Toolbar className="navbarlanding">

                    <Grid item xs={12} lg={2}>
                            <Link to={"/"}>
                                <img src={logo} alt="logo" width="200px" />
                            </Link>
                    </Grid>

                    <Grid item xs={12} lg={8} classname='miidlebutton'>
                        <Stack direction="row" spacing={3}>
                            <Typography variant='h6'><Link to="/" style={{ textDecoration: 'none', color: '#ffff' }}>Home</Link></Typography>

                            <Typography variant='h6'><Link to="/" style={{ textDecoration: 'none', color: '#ffff' }}>About</Link></Typography>

                            <Typography variant='h6'><Link to="/retailer_signup" style={{ textDecoration: 'none', color: '#ffff' }}>Register </Link></Typography>

                            <Typography variant='h6'><Link to="/contactus" style={{ textDecoration: 'none', color: '#ffff' }}>Contact</Link></Typography>
                        </Stack>
                    </Grid>


                    <Grid item xs={12} lg={2}>
                        <Stack direction="row" spacing={3}>
                            <Typography variant='h6'><Link to="/retailer_signup" style={{ textDecoration: 'none', color: '#ffff' }}>Sign up</Link></Typography>
                            <Link to="/retailer_login">
                                <Button style={{ backgroundColor: '#ffff', color: 'black' }}>Login</Button>
                            </Link>
                        </Stack>
                    </Grid>


                </Toolbar>
            </AppBar>
        </Box>
    );
}